/**
 * Shared Google Maps style array used by every interactive map on the
 * site (branches map, library-square map). Hides POIs + transit stations
 * but keeps parks visible.
 *
 * Note: Google ignores the `styles` option when a `mapId` is also set on
 * the Map instance (because mapId-based styling is meant to come from
 * Google Cloud's Map Styles UI). If you want these rules to take effect
 * alongside our advanced markers, mirror them in the cloud style for the
 * relevant Map IDs.
 */
export const HIVE_MAP_STYLES = [
  {
    featureType: "poi",
    elementType: "all",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.park",
    elementType: "all",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "transit.station",
    elementType: "all",
    stylers: [{ visibility: "off" }],
  },
];
